import React from 'react';
import { useTranslation } from 'react-i18next';
import SystemSectionTabsLayout from '../../../shared/ui/system-section-tabs/system-section-tabs-layout.jsx';

function SystemUserSettingsLayout() {
  const { t } = useTranslation();
  const USER_SETTINGS_TABS = [
    { key: 'agreements', label: t('systemNav.agreementsTab'), to: '/system/user-settings/agreements' },
    { key: 'jurisdictions', label: t('systemNav.jurisdictionsTab'), to: '/system/user-settings/jurisdictions' },
    { key: 'trading-platforms', label: t('systemNav.tradingPlatformsTab'), to: '/system/user-settings/trading-platforms' },
    { key: 'trading-servers', label: t('systemNav.tradingServersTab'), to: '/system/user-settings/trading-servers' },
    { key: 'trading-accounts', label: t('systemNav.tradingAccountsTab'), to: '/system/user-settings/trading-accounts' },
    { key: 'email-templates', label: t('systemNav.emailTemplatesTab'), to: '/system/user-settings/email-templates' },
    { key: 'kyc', label: t('systemNav.kycTab'), to: '/system/user-settings/kyc' },
    { key: 'backup-restore', label: t('systemNav.settingsBackupTab'), to: '/system/user-settings/backup-restore' },
  ];
  return <SystemSectionTabsLayout tabs={USER_SETTINGS_TABS} />;
}

export default SystemUserSettingsLayout;
